import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

Vue.config.productionTip = false;

const firebaseApp = initializeApp({
  apiKey: "AIzaSyAlyANRyS2Jq_OYZIaSyXgggl0vPPbPMYY",
  authDomain: "inventory2-71430.firebaseapp.com",
  projectId: "inventory2-71430",
  storageBucket: "inventory2-71430.appspot.com",
  messagingSenderId: "579956416423",
  appId: "1:579956416423:web:7566172db86d3baf662082",
  measurementId: "G-WZ4LV15YCY",
});
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export { db, auth };

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
